
var SWIPE_THRESHOLD = 1000;
/*! tocca v0.1.4 || Gianluca Guarini */
!function (a, b) { "use strict"; if ("function" != typeof a.createEvent) return !1; var c, d, e, f, g, h, i, j = "undefined" != typeof jQuery, k = !!navigator.pointerEnabled || navigator.msPointerEnabled, l = !!("ontouchstart" in b) && navigator.userAgent.indexOf("PhantomJS") < 0 || k, m = function (a) { var b = a.toLowerCase(), c = "MS" + a; return navigator.msPointerEnabled ? c : b }, n = { touchstart: m("PointerDown") + " touchstart", touchend: m("PointerUp") + " touchend", touchmove: m("PointerMove") + " touchmove" }, o = function (a, b, c) { for (var d = b.split(" "), e = d.length; e--;) a.addEventListener(d[e], c, !1) }, p = function (a) { return a.targetTouches ? a.targetTouches[0] : a }, q = function () { return (new Date).getTime() }, r = function (b, e, f, g) { var h = a.createEvent("Event"); if (g = g || {}, g.x = c, g.y = d, g.distance = g.distance, j) jQuery(b).trigger(e, g); else { h.originalEvent = f; for (var i in g) h[i] = g[i]; h.initEvent(e, !0, !0), b.dispatchEvent(h) } }, s = function (a) { var b = p(a); e = c = b.pageX, f = d = b.pageY, h = q(), A++ }, t = function (a) { var b = [], j = f - d, k = e - c; if (clearTimeout(g), -v >= k && b.push("swiperight"), k >= v && b.push("swipeleft"), -v >= j && b.push("swipedown"), j >= v && b.push("swipeup"), b.length) for (var l = 0; l < b.length; l++) { var m = b[l]; r(a.target, m, a, { distance: { x: Math.abs(k), y: Math.abs(j) } }) } else h + w - q() >= 0 && e >= c - y && c + y >= e && f >= d - y && d + y >= f && (r(a.target, 2 === A && i === a.target ? "dbltap" : "tap", a), i = a.target), g = setTimeout(function () { A = 0 }, x) }, u = function (a) { var b = p(a); c = b.pageX, d = b.pageY }, v = b.SWIPE_THRESHOLD || 100, w = b.TAP_THRESHOLD || 150, x = b.DBL_TAP_THRESHOLD || 200, y = b.TAP_PRECISION / 2 || 30, z = b.JUST_ON_TOUCH_DEVICES || l, A = 0; o(a, n.touchstart + (z ? "" : " mousedown"), s), o(a, n.touchend + (z ? "" : " mouseup"), t), o(a, n.touchmove + (z ? "" : " mousemove"), u) }(document, window);

extraJQueryFunctions.push(function ($) {

    //Remove nav fixed on devices
    $(window).bind("load resize", function () {
        if ($(window).width() < 1025) {
            $('.nav_wrapper').removeClass("navbar-fixed-top");
        } else {

            var navHeight = $('.nav_wrapper').height();

            if (navHeight > 250) {
                $('body').css({
                    "padding-top": "260px"
                })
            }

            $('.nav_wrapper').addClass("navbar-fixed-top");
            $(window).scroll(function () {
                if ($(window).scrollTop() > 250) {
                    $('body').addClass("nav-scrolled");
                } else {
                    $('body').removeClass("nav-scrolled");
                }
            });
        }
    });

    $("ul").each(function () {
        var highlightedLink = $(this).find('a[href="' + $(location).attr('pathname') + '"]');
        highlightedLink.parents("li").addClass("active");
    });

    $(".navbar#navigation ul.dropdown-menu").each(function () {
        var parentDropdown = $(this);

        parentDropdown.menuAim({
            tolerance: 50,
            activate: function (row) {
                if ($(".navbar#navigation").hasClass("touch_events_detected")) {
                    return;
                }

                if ($(row).children().length > 0) {
                    if ($(row).hasClass("dropdown")) {
                        $(row).addClass("maintain_hover");
                        parentDropdown.children("li").not($(row)).addClass("block_hover");

                    }
                }
            },
            deactivate: function (row) {
                if ($(".navbar#navigation").hasClass("touch_events_detected")) {
                    return;
                }

                if ($(row).children().length > 0) {
                    if ($(row).hasClass("dropdown")) {
                        $(row).removeClass("maintain_hover");
                        parentDropdown.find("li").not($(row)).removeClass("block_hover");
                    }
                }
            },
            exitMenu: function () { return true;}
        });
    });

    function scrollOnDropdownHover(element, extraTop) {
        $("html, body").stop().animate({
            scrollTop: element.offset().top - extraTop
        }, 200, function () {
            element.addClass("maintain_hover");
        });
    }

    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/ig) || userAgent.match(/iPhone/ig)) {
        $("#navigation .navbar-header").on("touchstart", function () {
            if (!$(event.target).is(".navbar-toggle")) {
                $("#navigation .navbar-toggle").click();
            }
        });
    }

    var startY;
    var endY;
    var startScroll;

    $("#navigation-content > ul > li.dropdown > a").on("touchstart", function (event) {
        $(".navbar#navigation").addClass("touch_events_detected");

        $("#navigation-content > ul > li.dropdown,.navigation_overlay,#navigation-content > ul > li:not(.dropdown)").off("mouseenter");

        startY = event.originalEvent.touches[0].pageY;
        startScroll = $(window).scrollTop();
    });

    $("#navigation-content > ul > li.dropdown > a").on("touchmove", function (event) {
        endY = event.originalEvent.touches[0].pageY;
    });

    $("#navigation-content > ul > li.dropdown > a").on("touchend", function (event) {
        var dropdown = $(this).closest("li");

        var isMobile = (window.matchMedia && window.matchMedia("screen and (max-width : 767px)").matches) || (!window.matchMedia && window.screen.availWidth && window.screen.availWidth < 768);

        if (!dropdown.hasClass("maintain_hover") && (!isMobile || !dropdown.hasClass("mega_dropdown"))) {
            event.preventDefault();
            if (Math.abs(startY - endY) > 30 || Math.abs(startScroll - $(window).scrollTop()) > 30) {
                event.stopPropagation();
            }

        }
    });

    $(".navbar#navigation li.dropdown").on("touchend", function (event) {
        $(".navbar#navigation").addClass("touch_events_detected");

        var dropdown = $(this);

        var isMobile = (window.matchMedia && window.matchMedia("screen and (max-width : 767px)").matches) || (!window.matchMedia && window.screen.availWidth && window.screen.availWidth < 768);

        if (!dropdown.hasClass("maintain_hover") && (!isMobile || !dropdown.hasClass("mega_dropdown"))) {
            event.preventDefault();
            event.stopPropagation();

            if (isMobile) {

                var siblingsBefore = dropdown.siblings(".maintain_hover");
                var openHeight = 15;

                siblingsBefore.each(function () {
                    $(this).children(".dropdown-menu").each(function () {
                        openHeight += $(this).height() + 21;
                    });
                });

                siblingsBefore.each(function () {
                    $(this).children(".dropdown-menu").animate({ height: 0 }, 200, function () {
                        $(this).parent().removeClass("maintain_hover");
                        $(this).css("height", "auto");
                    });
                });

                scrollOnDropdownHover(dropdown, openHeight);

            } else {
                dropdown.siblings().removeClass("maintain_hover");
                dropdown.addClass("maintain_hover");
            }
        }
    });

    $(".navbar#navigation li.dropdown").each(function () {
        var dropdown = $(this);

        dropdown.children("a").on("focusin", function () {
            if ($(".navbar#navigation").hasClass("touch_events_detected")) return;
            if (!dropdown.hasClass("maintain_hover")) {
                dropdown.addClass("maintain_hover");
            }
        });

        dropdown.find("a, iframe").last().on("focusout", function () {
            if ($(".navbar#navigation").hasClass("touch_events_detected")) return;
            dropdown.removeClass("maintain_hover");
        });
    });

    $(".navbar#navigation li.dropdown + li").each(function () {
        var dropdown = $(this);

        dropdown.children("a").on("focusin", function () {
            if ($(".navbar#navigation").hasClass("touch_events_detected")) return;
            dropdown.prev().removeClass("maintain_hover").find(".maintain_hover").removeClass("maintain_hover");
        });
    });

    $(".navbar#navigation .nav > .dropdown").each(function () {
        var dropdown = $(this);
        var offset = dropdown.offset().left;
        
        dropdown.find(">ul").each(function () {
            if (offset + $(this).width() + $(this).find(".sub-menu").width() > $(window).width()) {
                $(this).closest("li").addClass("right-menu");
            }
        });        
    });
});